import React from 'react';
import { createRoot } from 'react-dom/client';
import LandingPage from '../components/tournaments/LandingPage.jsx';
import TournamentsLayout from '../components/tournaments/TournamentsLayout.jsx';

const root = createRoot(document.getElementById('root'));
root.render(
  <TournamentsLayout active="landing">
    <LandingPage
      onOpen={id => {
        window.location.href = `/tournament.html?id=${id}`;
      }}
      onCreate={() => {
        window.location.href = '/admin.html?new=1';
      }}
    />
  </TournamentsLayout>
);
